import { FC, memo } from 'react';

import V2GaragesPresenter from './V2GaragesPresenter';

const V2Garages: FC = memo(() => (
  <V2GaragesPresenter />
));

export default V2Garages;
